import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addCustomOption } from "../../../../store/slices/customSelectSlice";
import { setNewAssistant } from "../../../../store/slices/assistantSlice"; // путь замени на свой
import styles from "./CustomMultiSelect.module.scss";
import { XmarkIcon } from "../../../../assets/icons/XmarkIcon";
import {
  CheckIcon,
  ChevronDownIcon,
  ChevronUpIcon,
} from "@radix-ui/react-icons";

const defaultOptions = ["Имя", "Телефон"];

export const CustomMultiSelect = () => {
  const dispatch = useDispatch();

  const newAssistant = useSelector((state) => state.assistant.newAssistant);
  const customOptions = useSelector(
    (state) => state.customSelect.customOptions
  );
  const collectedData = useSelector(
    (state) => state?.assistant?.newAssistant?.collectedData
  );

  const [selected, setSelected] = useState(collectedData || []);
  const [isOpen, setIsOpen] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const allOptions = [...defaultOptions, ...customOptions];

  const toggleValue = (value) => {
    let updated;
    if (selected.includes(value)) {
      updated = selected.filter((v) => v !== value);
    } else {
      updated = [...selected, value];
    }
    setSelected(updated);
  };

  const handleAdd = () => {
    const trimmed = inputValue.trim();
    if (trimmed && !allOptions.includes(trimmed)) {
      dispatch(addCustomOption(trimmed));
      setSelected([...selected, trimmed]);
    }
    setInputValue("");
    setIsAdding(false);
  };

  // Синхронизируем selected -> collectedData
  useEffect(() => {
    if (
      JSON.stringify(newAssistant?.collectedData) !== JSON.stringify(selected)
    ) {
      dispatch(
        setNewAssistant({
          ...newAssistant,
          collectedData: selected,
        })
      );
    }
  }, [selected, dispatch, newAssistant]);

  return (
    <div className={styles.container}>
      <div className={styles.inputContainer} onClick={() => setIsOpen(!isOpen)}>
        {selected.length === 0 && (
          <p className={styles.placeholder}>Выберать данные</p>
        )}
        {selected.map((val) => (
          <div className={styles.selectedItem} key={val}>
            {val}
            <span
              className={styles.closeButton}
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation();
                toggleValue(val);
              }}
            >
              <XmarkIcon width={12} height={14} fill={"white"} />
            </span>
          </div>
        ))}
        <div
          className={styles.arrow}
          style={{ marginLeft: "auto", cursor: "pointer" }}
        >
          {isOpen ? (
            <ChevronUpIcon width={20} height={20} fill="#212121" />
          ) : (
            <ChevronDownIcon width={20} height={20} fill="#212121" />
          )}
        </div>
      </div>
      <small className={styles.smallText}>
        Список данных, которые ассистент соберёт в процессе диалога. Эти поля
        будут автоматически включены в сценарий общения.
      </small>

      {isOpen && (
        <div className={styles.optionsContainer}>
          {allOptions.map((opt) => (
            <div
              className={styles.option}
              key={opt}
              style={{
                color: selected.includes(opt) ? "#006AD7" : "#212121",
              }}
              onClick={() => toggleValue(opt)}
            >
              {opt}
            </div>
          ))}

          {!isAdding ? (
            <div className={styles.option} onClick={() => setIsAdding(true)}>
              Добавить своё
            </div>
          ) : (
            <div
              className={styles.option}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 4,
              }}
            >
              <input
                className={styles.input}
                placeholder="Введите значение"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
              />
              <span
                className={styles.check}
                style={{ cursor: "pointer" }}
                onClick={handleAdd}
              >
                <CheckIcon width={20} height={20} fill="#212121" />
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
